import { Component, EventEmitter, Input, NgZone, OnInit, OnChanges, Output, SimpleChanges, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Location } from '@angular/common';
import { Title } from '@angular/platform-browser';
import { take } from 'rxjs/operators';
import { UntypedFormBuilder } from '@angular/forms';
import { GridComponent, GridDataResult, DataStateChangeEvent } from '@progress/kendo-angular-grid';
import { process, State, orderBy } from '@progress/kendo-data-query';
import { CRMService } from '../../services/crm.service';
import { EmployeeService } from '../../services/employees.service';
import { UtilService } from '../../services/util.service';
import {
    Customer
    , Employee
    , SearchCustomerOpportunity
} from '../../models/models';

@Component({
    selector: 'customer-opportunity-grid',
    templateUrl: './customer-opportunity-grid.component.html',
    standalone: false
})
export class CustomerOpportunityGrid implements OnInit, OnChanges {
    @Input() title: string = "Opportunities";
    @Input() expanded: boolean = true;
    @Input() customerID: number = 0;
    @Input() customerCode: string = "";
    //@Input() productID: number = 0;
    @Input() serviceID: number = 0;

    @Output() opportunitySaved: EventEmitter<boolean> = new EventEmitter<boolean>();

    @ViewChild(GridComponent, { static: false }) public opportunityGrid!: GridComponent;

    public isEditOpportunity: boolean = false;
    public isAddOpportunity: boolean = false;
    public opportunityID: number = 0;
    public productID: number = 0;
    public opportunitySalesCycleMapID: number = 0;

    //private selectedCustomerId: number = 0;
    //private selectedProductId: string = '';
    //private editedRowIndex: number | undefined;
    //private editedOpportunity: OpportunitySalesCycleMap = {} as OpportunitySalesCycleMap;

    public opportunityList: SearchCustomerOpportunity[] = [];
    public customer: Customer = {} as Customer;
    private employees: Employee[] = [];

    public gridData: GridDataResult = { data: [], total: 0 };
    public gridState: State = { skip: 0, take: 20, sort: [{ dir: 'asc', field: 'productName' }, { dir: 'asc', field: 'title' }] };

    constructor(private route: ActivatedRoute, private router: Router, private titleService: Title, private location: Location,
        private crmService: CRMService, private employeeService: EmployeeService, private utilService: UtilService,
        private ngZone: NgZone, private formBuilder: UntypedFormBuilder) {
    }

    ngOnInit() {
        this.getEmployees();

        this.route.params.subscribe(params => {
            //console.log("getOpportunities:route.params", this.opportunityID, this.route.params);
            //this.opportunityID = params.opportunityID
            if (params.opportunityID > 0) {
                this.edit(params.opportunityID, false);
            }
        });
    }

    ngOnChanges(changes: SimpleChanges) {
        if (changes.customerID == null
            || changes.customerID.currentValue == null
            || parseInt(changes.customerID.currentValue.toString()) < 1) return;

        this.customerID = parseInt(changes.customerID.currentValue.toString());
        this.getOpportunities();
        this.getCustomer();
    }

    private getEmployees() {
        this.employeeService.getEmployeesByGroupName('crm user').subscribe(result => {
            this.employees = result;
        });
    }

    private getOpportunities() {
        if (this.customerID < 1) return;

        this.utilService.isLoading = true;
        this.crmService.getSearchCustomerOpportunityByCustomerID(this.customerID).subscribe(result => {
            this.utilService.isLoading = false;
            this.opportunityList = result.resultCollection;
            this.setOpportunitiesGrid();
            if (this.opportunityID > 0) {
                this.edit(this.opportunityID, true);
            }
        });
    }

    private getCustomer() {
        if (this.customerID < 1) return;

        this.utilService.isLoading = true;
        this.crmService.getCustomerById(this.customerID).subscribe(result => {
            this.utilService.isLoading = false;
            this.customer = result;
        });
    }

    private setOpportunitiesGrid() {
        if (this.gridState.sort) this.opportunityList = orderBy(this.opportunityList, this.gridState.sort);

        this.gridData = process(this.opportunityList, this.gridState);
        this.fitColumns();
    }

    private fitColumns() {
        this.ngZone.onStable.asObservable().pipe(take(1)).subscribe(() => {
            if (this.opportunityGrid == null) return;
            this.opportunityGrid.autoFitColumns();
        });
    }

    public dataStateChange(state: DataStateChangeEvent) {
        this.gridState = state;
        this.setOpportunitiesGrid();
    }

    public edit(opportunityID: number, isNav: boolean) {
        this.opportunityID = opportunityID;
        this.isEditOpportunity = true;
        this.isAddOpportunity = false;

        //console.log("edit", this.opportunityID);

        if (isNav) {
            var opp = this.opportunityList.find(t => t.opportunityID == opportunityID);
            this.opportunitySalesCycleMapID = opp!.opportunitySalesCycleMapID;

            //this.selectedOpp = opp;
            this.productID = opp!.productID;

            //this.router.navigate(['customer-detail', this.customerCode, this.opportunityID]);
            this.location.replaceState("/customer-detail/" + this.customerCode + "/" + this.opportunityID);
            this.titleService.setTitle(this.customerCode + ' - Opportunity: ' + opp!.title);
        }
    }

    public addNew() {
        this.opportunityID = 0;
        this.isEditOpportunity = false;
        this.isAddOpportunity = true;
    }

    public cancelEdit() {
        this.opportunityID = 0;
        this.isEditOpportunity = false;
        this.isAddOpportunity = false;
        this.location.replaceState("/customer-detail/" + this.customerCode);
        this.titleService.setTitle('Customer Profile - ' + this.customerCode);
    }

    public refreshAfterSave() {
        this.cancelEdit();
        this.getOpportunities();
    }
}
